/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormHelpersService {
  constructor() {}

  isInputInvalid(formGroup: FormGroup, controlName: string, searchTerm?: string) {
    const control = formGroup.get(controlName);
    if (searchTerm) {
      return (control.dirty || control.touched) && searchTerm.length === 0;
    }
    return control && control.invalid && (control.dirty || control.touched);
  }

  isInputValid(formGroup: FormGroup, controlName: string) {
    const control = formGroup.get(controlName);
    return control && control.valid && (control.dirty || control.touched);
  }

  hasError(formGroup: FormGroup, controlName: string, errorProp?: string) {
    const control = formGroup.get(controlName);
    if (errorProp) {
      return control && (control.dirty || control.touched) && control.errors && control.errors[errorProp];
    }
    return control && control.errors && (control.dirty || control.touched);
  }

  markFieldsAsDirty(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.get(key).markAsDirty();
    });
  }

  markFieldsAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      formGroup.get(key).markAsTouched();
    });
  }

  hasField(formGroup: FormGroup, controlName: string) {
    return !!formGroup?.get(controlName);
  }
}
